export const ASSESSMENT_DRAFT_STORAGE_KEY = "rc_assessment_draft";

const normalizeDraftEmail = (email) => String(email || "").trim().toLowerCase();

export const hasMeaningfulAssessmentDraft = (draft) => {
  if (!draft || typeof draft !== "object") return false;

  const data = draft.formData || {};
  return Boolean(
    data.current_country ||
    data.citizenship ||
    (Array.isArray(data.motivations) && data.motivations.length) ||
    (Array.isArray(data.priorities) && data.priorities.length) ||
    data.budget_range ||
    data.timeline ||
    data.intended_length_of_stay ||
    data.additional_notes ||
    Number.isInteger(draft.currentStep)
  );
};

export const readAssessmentDraft = (expectedUserEmail = null) => {
  if (typeof window === "undefined") return null;

  try {
    const rawDraft = window.localStorage.getItem(ASSESSMENT_DRAFT_STORAGE_KEY);
    if (!rawDraft) return null;
    const parsedDraft = JSON.parse(rawDraft);

     if (expectedUserEmail) {
      const expected = normalizeDraftEmail(expectedUserEmail);
      const stored = normalizeDraftEmail(parsedDraft?.userEmail);
      if (!stored || stored !== expected) {
        return null;
      }
    }

    return hasMeaningfulAssessmentDraft(parsedDraft) ? parsedDraft : null;
  } catch {
    return null;
  }
};

export const writeAssessmentDraft = (draft, userEmail = null) => {
  if (typeof window === "undefined") return;

  try {
    if (!hasMeaningfulAssessmentDraft(draft)) {
      window.localStorage.removeItem(ASSESSMENT_DRAFT_STORAGE_KEY);
      return;
    }

    window.localStorage.setItem(
      ASSESSMENT_DRAFT_STORAGE_KEY,
      JSON.stringify({
        ...draft,
        userEmail: normalizeDraftEmail(userEmail),
      })
    );
  } catch {
    // Ignore storage write failures silently.
  }
};

export const clearAssessmentDraft = () => {
  if (typeof window === "undefined") return;

  try {
    window.localStorage.removeItem(ASSESSMENT_DRAFT_STORAGE_KEY);
  } catch {
    // Ignore storage cleanup failures silently.
  }
};